import React from 'react'
import { Avatar as _Avatar } from 'antd';
import { noImage } from 'configs/constants';


export const Avatar = props => {
    return (<_Avatar {...props} src={props.src || noImage} />)
    // return (<_Avatar {...props} src={props.src}>{props.src ? null : props.children}</_Avatar>)
}
